module.exports = __webpack_public_path__ + "img/40_00_000_310.f02245e2.jpg";